import http from "@/http-common";

class EvaluationPeriodStatisticsService {
  getWeekly(date, gradeId, classId) {
    return http.get("statistics/evaluation/weekly", {
      params: { date, gradeId: gradeId || undefined, classId: classId || undefined }
    });
  }

  getMonthly(month, gradeId, classId) {
    return http.get("statistics/evaluation/monthly", {
      params: { month, gradeId: gradeId || undefined, classId: classId || undefined }
    });
  }

  getPeriodic(year, periodNumber, date, gradeId, classId) {
    return http.get("statistics/evaluation/periodic", {
      params: { year, periodNumber, date,
        gradeId: gradeId || undefined, classId: classId || undefined }
    });
  }
}

export default new EvaluationPeriodStatisticsService();
